import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { APP_ID, ApplicationConfig, inject, LOCALE_ID } from '@angular/core'
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser'
import {
  NoPreloading,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router'
import { GRAPHQL_ENDPOINT_PATH } from '@pai/commons'

import { provideClientConfig } from 'app/core/client-config/provide-client-config.function'
import { ensureOriginInterceptor } from 'app/core/origin/ensure-origin.interceptor'

import { CURRENT_LANG } from './core/i18n/language.token'
import { provideTranslator } from './core/i18n/provide-translator.function'
import { provideJsonLd } from './core/meta/provide-json-ld'
import { provideMetaService } from './core/meta/provide-meta-service.function'
import { routes } from './routes/routes.const'

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_ID, useValue: 'pai' },

    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        // we first need to enable POST requests to include as well to be able to filter them ourselves
        includePostRequests: true,
        filter: (req) => {
          switch (req.method) {
            case 'GET':
              return true
            case 'POST':
              return URL.parse(req.url)?.pathname === GRAPHQL_ENDPOINT_PATH
            default:
              return false
          }
        },
      }),
    ),

    provideHttpClient(withFetch(), withInterceptors([ensureOriginInterceptor])),

    provideRouter(
      routes,
      withInMemoryScrolling(),
      withPreloading(NoPreloading),
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),

    { provide: LOCALE_ID, useFactory: () => `${inject(CURRENT_LANG)}-CH` },
    provideClientConfig(),
    provideTranslator(), // app initializer inside
    provideMetaService(),
    provideJsonLd(), // app initializer inside
  ],
}
